export const __REACT_PREPARE__ = '@__REACT_PREPARE__@';
